<template lang="pug">
el-card(shadow="hover").pvtnCard
  el-row.center
    el-col.flex(:span="10")
      span Início de vigência:
      el-date-picker(
        v-model="pvtn.inicio",
        format="dd/MM/yyyy",
        v-mask="'##/##/#####'",
        value-format="yyyy-MM-dd",
        placeholder="Selecione",
        type='date',
        :disabled="isVisualizar"
      )
    el-col.flex(:span="10")
      span Final de vigência:
      el-date-picker(
        v-model="pvtn.fim",
        format="dd/MM/yyyy",
        value-format="yyyy-MM-dd",
        v-mask="'##/##/#####'",
        placeholder="Selecione",
        type='date',
        :disabled="isVisualizar"
      )
</template>

<script>
export default {

  props: {
    pvtn: {
      type: Object,
      required: true
    },
    isVisualizar: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.pvtnCard {
  border-bottom: 4px solid gainsboro;
}

.flex {
  width: 32%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.center {
  display: flex;
  gap: 2%;
}

#line {
  width: 100%;
  background-color: gainsboro;
  height: 2px;
  margin-top: 11px;
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/PvtnVigenciaCard.vue